export default {
    set(key, value) {
        window.sessionStorage.setItem(key, value);
    },
    setBoolean(key, value) {
        window.sessionStorage.setItem(key, !!value ? "true" : "false");
    },
    setObject(key, value) {
        window.sessionStorage.setItem(key, JSON.stringify(value));
    },
    getObject(key) {
        const value = window.sessionStorage.getItem(key);

        if (!value) {
            return null;
        }

        try {
            return JSON.parse(value);
        } catch {
            return null;
        }
    },
    setInt(key, value) {
        if (parseInt(value, 10) !== value) {
            throw Error("Not int: " + value);
        }

        window.sessionStorage.setItem(key, value);
    },
    /**
     * Default 0 if not in storage.
     */
    getInt(key) {
        const value = window.sessionStorage.getItem(key);

        if (!value) {
            return 0;
        }

        return parseInt(value, 10);
    },
    get(key) {
        return window.sessionStorage.getItem(key);
    },
    getBoolean(key) {
        return window.sessionStorage.getItem(key) === "true";
    },
    delete(key) {
        window.sessionStorage.removeItem(key);
    },
    getAllKeys() {
        return Object.keys(window.sessionStorage);
    },
};
